




















import { Component, Prop, Vue } from 'vue-property-decorator';
import Client from '../../models/Client';
import BillingForm from './components/BillingForm.vue';
import users from '@/store/modules/users';
import clients from '@/store/modules/clients';

@Component({
  components: {
    BillingForm,
  },
})
export default class Billing extends Vue {
  @Prop() private client!: any;
  private loading = false;
  private errMessage = '';
  private successMessage = '';

  private setError(err: string) {
    this.errMessage = err;
  }

  private setSuccess(res: any) {
    this.successMessage = res.info;
    clients.editClient({
      clientId: this.client.holded.id,
      data: { holdedId: res.contact.id },
    });
  }
}
